import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

import { PREVIOUS_VISITS_PAGE_SIZE, UPCOMING_VISITS_PAGE_SIZE, type VisitorsProfilesShowModel } from './route';

type TabValue = 'visits' | 'aliases';

export default class VisitorsProfilesShowController extends Controller {
  declare model: VisitorsProfilesShowModel;

  queryParams = ['upcomingVisitsCursor', 'previousVisitsCursor', 'from', 'id', 'tab'];
  @tracked upcomingVisitsCursor: string | null = null;
  @tracked previousVisitsCursor: string | null = null;
  @tracked from: string | null = null;
  @tracked id: string | null = null;
  @tracked tab: TabValue = 'visits';
  @tracked upcomingVisitsIsLoading: boolean = false;
  @tracked previousVisitsIsLoading: boolean = false;

  get upcomingVisitsPageSize(): number {
    return UPCOMING_VISITS_PAGE_SIZE;
  }

  get previousVisitsPageSize(): number {
    return PREVIOUS_VISITS_PAGE_SIZE;
  }

  get backLink(): { route: string; model: string } {
    return { route: this.#routeFrom, model: this.id || '' };
  }

  @action
  setUpcomingVisitsCursor(cursor: string | null): void {
    this.upcomingVisitsIsLoading = true;
    this.upcomingVisitsCursor = cursor;
  }

  @action
  setPreviousVisitsCursor(cursor: string | null): void {
    this.previousVisitsIsLoading = true;
    this.previousVisitsCursor = cursor;
  }

  @action
  setTab(tab: TabValue): void {
    this.tab = tab;
  }

  get #routeFrom(): string {
    switch (this.from) {
      case 'entry':
        return 'visitors.entry';
      case 'invite':
        return 'visitors.invites.show';
      default:
        return 'visitors.profiles';
    }
  }
}
